var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/an-object.js
// module id = 4
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35